import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { Box, Button, Text } from 'components/common'
import ModalLoader from 'components/common/Loader/ModalLoader'
import { old_COLOR } from 'styles/constants/old_color'
import { old_FONT_SIZE } from 'styles/constants/old_fontSize'
import { old_SPACE } from 'styles/constants/old_space'

type Props = {
  hideModal: () => void
  onClick: () => void
  showModal: boolean
  isLoading: boolean
}

export default function ConfirmCreateTemplateModal({
  hideModal,
  onClick,
  isLoading,
  showModal,
}: Props) {
  return (
    <Modal isOpen={showModal} onClose={hideModal} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Box>
            <Text color={old_COLOR.coolGray600} fontSize={old_FONT_SIZE.fs16}>
              Confirm template creation?
            </Text>
          </Box>
        </ModalHeader>
        <ModalBody>
          <Box>
            <Text color={old_COLOR.coolGray600} fontSize={old_FONT_SIZE.fs14}>
              Are you sure you want to create an investment template?
            </Text>
          </Box>
          <Box marginTop={old_SPACE.sp12}>
            <Text color={old_COLOR.coolGray600} fontSize={old_FONT_SIZE.fs14}>
              Once you have created a template, you will no longer be able to
              change its asset class. This means you will not be able to switch
              from equity only to multi asset class or vice versa.
            </Text>
          </Box>
          <Box marginTop={old_SPACE.sp12}>
            <Text color={old_COLOR.coolGray600} fontSize={old_FONT_SIZE.fs14}>
              If you would like to change a portfolio’s asset class, either
              create a new template and apply the new template or remove the
              template and edit the portfolio’s investment preferences directly.
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter marginBottom={old_SPACE.sp8}>
          <Box width="100%">
            <Box marginBottom={old_SPACE.sp12}>
              <Button
                onClick={onClick}
                size="md"
                variant="primary"
                width="100%"
                disabled={isLoading}
              >
                Confirm
              </Button>
            </Box>

            <Button
              onClick={hideModal}
              size="md"
              variant="secondary"
              width="100%"
              active={false}
            >
              Cancel
            </Button>
            {isLoading && <ModalLoader />}
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
